import { render, staticRenderFns } from "./PrintPanelPlugin.vue?vue&type=template&id=320a2040&scoped=true"
import script from "./PrintPanelPlugin.vue?vue&type=script&lang=ts"
export * from "./PrintPanelPlugin.vue?vue&type=script&lang=ts"
function injectStyles (context) {
  
  var style0 = require("./PrintPanelPlugin.vue?vue&type=style&index=0&id=320a2040&prod&scoped=true&lang=less")
if (style0.__inject__) style0.__inject__(context)

}

/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  "320a2040",
  null
  ,true
)

export default component.exports